import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { CartSettingContent, CartSettingSwitchItem, CartSettingSwitchWrap, CartSettingTitle } from '../index.styled'
import SwitchInputControlled from '../../../Elements/inputs/SwitchInput/controlled'
import { updateCashDeskSettingsCartSettingsThunk } from '../../../../redux/thunk/cashDeskSettings'
import { businessScopeConfig, CASH_DESK_MODULE } from '../../constants'

const CashDeskProductQuantitySettings = React.memo(() => {
	const { t } = useTranslation()
	const cartSettings = useSelector(store => store.cashDeskSettings.cartSettings)
	const dispatch = useDispatch()

	const changeCartSetting = useCallback((e, businessScope) => {
		dispatch(updateCashDeskSettingsCartSettingsThunk({
			businessScope,
			module: CASH_DESK_MODULE,
			showProductQuantity: e.target.checked,
		}))
	}, [dispatch])


	return (
		<CartSettingContent>
			<CartSettingTitle>{t('Settings.TextCartSettings')}</CartSettingTitle>
			<CartSettingSwitchWrap>
				{businessScopeConfig.map((config, index) => {
					const businessScope = config.businessScope
					const setting = cartSettings.find(item => item.businessScope === businessScope)
					const isActive = setting?.showProductQuantity
					const layout = isActive ? 'active' : ''
					return (
						<CartSettingSwitchItem key={index} className={layout}>
							<SwitchInputControlled name={`enabled-${businessScope}-product-quantity`}
																		 testId={`enabled-${businessScope}-product-quantity`}
																		 checked={isActive}
																		 onChange={e => changeCartSetting(e, businessScope)}
																		 label={t(config.title)} />
						</CartSettingSwitchItem>
					)
				})}
			</CartSettingSwitchWrap>
		</CartSettingContent>
	)
})

CashDeskProductQuantitySettings.displayName = 'CashDeskProductQuantitySettings'
export default CashDeskProductQuantitySettings
